import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
const Footer = () => {
    const { t } = useLanguage();
    const footerStyle = {
      position: 'fixed', bottom: 0, width: '100%', padding: '10px',
      backgroundColor: '#f8f8f8', borderTop: '1px solid #ddd', textAlign: 'center'
    }
    const linkStyle = {
    margin: '0 8px',
    color: '#6c757d',
    textDecoration: 'none',
    transition: 'color 0.3s'
  };
  const linkHover = (e) => e.target.style.color = '#007bff';
  const linkOut = (e) => e.target.style.color = '#6c757d';

  return (
    <footer style={footerStyle}>
      <div style={{ marginBottom: '10px', flexWrap: 'wrap' }}>
        <Link to="/privacy-policy" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('privacy_policy')}
        </Link>|
        <Link to="/terms-of-service" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('terms_of_service')}
        </Link>|
        <Link to="/faq" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('faq')}
        </Link>|
        <Link to="/contact" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('contact_us')}
        </Link>|
        <Link to="/about" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('about_us')}
        </Link>|
        <Link to="/return-policy" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('return_policy')}
        </Link>|
        <Link to="/features" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('features')}
        </Link>|
        <Link to="/pricing" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('pricing')}
        </Link>|
        <Link to="/user-guide" style={linkStyle} onMouseOver={linkHover} onMouseOut={linkOut}>
          {t('user_guide')}
        </Link>
      </div>
      <p>&copy; 2025 AT Delivery. جميع الحقوق محفوظة.</p>
    </footer>
  )
};

export default Footer;
